import * as React from 'react'

import {
    Stack,
    Box,
    Button
} from '@mui/material'
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom'

import {HashLink as Link } from "react-router-hash-link";

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';


import { HeaderComponent, HeaderContent, IconsDiv, Logo, LogoDiv, MobileDiv, NavItem,  NavMenu, SearchDiv } from './styles';

import LogoIcon from '../../../../assets/images/Logos/BHBUSMidia_fundo.png'
import SideBar from '../../../sidebar';
import Search from '../../../search';
import contentData from '../../../../content.json';

interface TopHeaderProps {
    reference: any;
    title?: any;
}

const TopHeader: React.FC<TopHeaderProps> = ({ reference, title }) => {

    const matches = useMediaQuery('(max-width:1100px)');

    const dataHeader = [
        {name:"INÍCIO", value: "home", link: '/'},
        {name:"NOSSA SOLUÇÃO", value: "nossol", link: '#nossol'},
        {name:"NÚMEROS", value: "num", link: '#num'},
        {name:"PRODUTOS", value: "prod", link: '#prod'},
        {name:"DEPOIMENTOS", value: "dep", link: '#dep'},
        {name:"PARCEIROS", value: "parc", link: '#parc'},
        {name:"CLIENTES", value: "cli", link: '#cli'},
        {name:"ORÇAMENTO", value: "orc", link: '#orc'},
    ]

    const Whatsap = 'https://api.whatsapp.com/send/?phone=5531982213102&text&type=phone_number&app_absent=0';
    const Linkedin = 'https://br.linkedin.com/company/gomidiabh';
    const Instagram = 'https://www.instagram.com/bhbusmidia/';

    const handleWhatsAppClick = () => {
        const url = `${Whatsap}`;
        window.open(url, '_blank');
    };

    const handleLinkedinClick = () => {
        const url = `${Linkedin}`;
        window.open(url, '_blank');
    };

    const handleInstagramClick = () => {
        const url = `${Instagram}`;
        window.open(url, '_blank');
    };

    React.useEffect(() => {
    },[title, reference])

    return (
        <HeaderComponent>
            {matches ? (
                 <MobileDiv>
                    <LogoDiv>
                        <Logo src={LogoIcon} height="50px"/>
                    </LogoDiv>
                    <IconsDiv>
                        <InstagramIcon
                            sx={{
                                width: "1.5em",
                                height: "1.5em",
                                cursor: "pointer",
                                backgroundColor: "var(--purple)",
                                color: "white",
                                borderRadius: "16px",
                                padding: "5px",
                                margin: '2px',
                            }}
                            onClick={handleInstagramClick}
                        />
                        <LinkedInIcon
                            sx={{
                                width: "1.5em",
                                height: "1.5em",
                                cursor: "pointer",
                                backgroundColor: "var(--purple)",
                                color: "white",
                                borderRadius: "16px",
                                padding: "5px",
                                margin: '2px',
                            }}
                            onClick={handleLinkedinClick}
                        />
                        <WhatsAppIcon
                            sx={{
                                width: "1.5em",
                                height: "1.5em",
                                cursor: "pointer",
                                backgroundColor: "var(--purple)",
                                color: "white",
                                borderRadius: "16px",
                                padding: "5px",
                                margin: '2px',
                            }}
                            onClick={handleWhatsAppClick}
                        />
                    </IconsDiv>
                    <Search data={contentData} />
                    <SideBar nome={dataHeader}/>
                </MobileDiv>
            ) : (
                <HeaderContent>
                    <LogoDiv>
                        <Logo src={LogoIcon}/>
                    </LogoDiv>
                    <NavMenu>
                        {dataHeader.map((item, index) => (
                            <React.Fragment key={item.value}>
                                <Link to={item?.link}>
                                    <NavItem
                                        key={item.value}
                                        active={item.value === 'home'}
                                        
                                    >
                                        {item.name}
                                    </NavItem>
                                </Link>
                                {index < dataHeader.length - 1 && (
                                    <span style={{ margin: '0 0.5px', color: 'var(--purple)' }}>|</span>
                                )}
                            </React.Fragment>
                        ))}
                            
                        <SearchDiv>
                        <Search data={contentData} />
                        {/* <div className="gcse-search"></div> */}
                        </SearchDiv>
                    </NavMenu>
                </HeaderContent>
            )}
        </HeaderComponent>
    );
}

export { TopHeader }